// js/ui/ResultScreen.js
// 結果頁：星級、目標達成、存檔碼匯出、回放提示、重試／下一關／返回。

export class ResultScreen {
  constructor(root) {
    this.root = root;
    this.el = document.createElement('div');
    this.el.className = 'screen hidden';
    this.root.appendChild(this.el);
  }

  hide() { this.el.classList.add('hidden'); this.el.innerHTML = ''; }

  // ev = evaluate() 結果；cb = {onRetry,onNext,onMenu,hasNext,exportCode}
  show(ev, status, cb) {
    this.el.classList.remove('hidden');
    const stars = '★'.repeat(ev.stars) + `<span class="empty">${'★'.repeat(3 - ev.stars)}</span>`;
    const statusText = status === 'win' ? '準時到達！' : '遲到了！';
    const goalRows = ev.goals.map((g) =>
      `<div class="row ${g.met ? 'met' : 'notmet'}"><span class="box"></span><span>${g.text}</span></div>`
    ).join('');

    this.el.innerHTML = `
      <div class="dialog pixbox">
        <div class="result-status ${status === 'win' ? 'win' : 'lose'}">${statusText}</div>
        <div class="result-stars">${stars}</div>
        <p class="sub">${status === 'win'
          ? `路線 ${ev.routeLen.toFixed(1)} 格 · ${ev.collisions} 次碰撞 · ${ev.elapsed.toFixed(1)} 秒`
          : '看看路線與實際足跡分岔在哪，再調整吧。'}</p>
        <div class="result-goals">${goalRows}</div>
        <div class="row-btns">
          <button class="btn" id="rs-retry">再試一次</button>
          <button class="btn" id="rs-next" ${cb.hasNext ? '' : 'disabled'}>下一關</button>
          <button class="btn secondary" id="rs-menu">返回選關</button>
        </div>
        <h2>備份／跨設備進度</h2>
        <p class="sub">複製下方存檔碼保存；在新設備貼入即可還原進度。</p>
        <textarea class="code-area" id="rs-code" readonly rows="3">${cb.exportCode}</textarea>
        <div class="row-btns">
          <button class="btn secondary" id="rs-copy">複製存檔碼</button>
        </div>
        <div id="rs-toast" class="toast hidden"></div>
      </div>
    `;

    this.el.querySelector('#rs-retry').onclick = cb.onRetry;
    this.el.querySelector('#rs-next').onclick = cb.onNext;
    this.el.querySelector('#rs-menu').onclick = cb.onMenu;
    this.el.querySelector('#rs-copy').onclick = () => {
      const code = this.el.querySelector('#rs-code').value;
      this._copy(code).then((ok) => this._toast(ok ? '已複製到剪貼簿' : '複製失敗，請手動選取複製'));
    };
  }

  _toast(msg) {
    const t = this.el.querySelector('#rs-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.remove('hidden');
    clearTimeout(this._tt);
    this._tt = setTimeout(() => t.classList.add('hidden'), 1800);
  }

  _copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(() => true).catch(() => false);
    }
    return Promise.resolve(false);
  }
}
